export default "__VITE_ASSET__7P8LGvzk__"